import React, { Component } from 'react';

class Popup extends Component {
    static defaultProps = { width:600, left:"5%", top:"5%" };

    constructor(props) {
        super(props);
        this.selected = this.selected.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);        
    }
    
    componentWillMount() {
        window.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown);
    }
    
    handleKeyDown(e) {
        if (e.key === "Escape") {
            this.props.close();
        }
    }
    
    selected(character) {
        if (typeof this.props.selected === "function") {
            this.props.selected(character);
        }
    }
    
    render() {
        return (
            <div className='popup' onClick={this.props.close}>
              <div className={this.props.fill ? 'popup_fill' : 'popup_inner'} style={{left:this.props.left, top:this.props.top, right:this.props.left}} onClick={(e) => e.stopPropagation()}>
                {this.props.children}
              </div>
            </div>
        );
    }
}

export default Popup;
